// extracted by mini-css-extract-plugin
export default {"otherTable":"AddOrderOther_otherTable__GutJF","editableField":"AddOrderOther_editableField__hAiYI","tooltip":"AddOrderOther_tooltip__JD5Mu"};